var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructTwoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 294,
    viewBox: "0 0 424 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.179889 13.8643C-0.965212 6.58297 4.66338 0 12.0342 0H390.621C396.529 0 401.558 4.29978 402.475 10.1357L423.706 145.136C423.901 146.371 423.901 147.629 423.706 148.864L402.475 283.864C401.558 289.7 396.529 294 390.621 294H12.0342C4.66338 294 -0.965214 287.417 0.179888 280.136L20.8244 148.864C21.0187 147.629 21.0187 146.371 20.8244 145.136L0.179889 13.8643Z",
    fill: "#799DD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructTwoBg);
export default __webpack_public_path__ + "static/media/instructTwoBg.ba002a306649a3edea2c5950ac4d502e.svg";
export { ForwardRef as ReactComponent };